import React from "react";

function FilterIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.333"
      height="18"
      fill="none"
      className="icon icon-filter"
      version="1.1"
      viewBox="0 0 15.333 18"
      {...props}
    >
      <g clipPath="url(#clip0_1515_55825)" transform="translate(-2.334 -3)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 12H3.335m1.667 0c0 1.105.746 2 1.666 2 .92 0 1.667-.895 1.667-2m-3.333 0c0-1.105.746-2 1.666-2 .92 0 1.667.895 1.667 2m6.667 6c0-1.105-.746-2-1.667-2-.92 0-1.667.895-1.667 2m3.334 0c0 1.105-.747 2-1.667 2s-1.667-.895-1.667-2m3.334 0h1.666m-5 0H3.334m5-6h8.333m-1.666-6c0-1.105-.746-2-1.667-2-.92 0-1.667.895-1.667 2m3.334 0c0 1.105-.747 2-1.667 2s-1.667-.895-1.667-2m3.334 0h1.666m-5 0H3.334"
        ></path>
      </g>
      <defs id="defs9">
        <clipPath id="clip0_1515_55825">
          <path
            id="rect6"
            fill="currentColor"
            d="M0 0H24V20H0z"
            transform="rotate(-90 12 12)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default FilterIcon;
